export function getJwtStorageKey(authId: string): string {
  return `republic-jwt-${authId}`;
}

export function getPasskeyDeviceStorageKey(authId: string): string {
  return `republic-wallet-passkeys-${authId}`;
}

/** Session-storage flag: this session already reported a Warp customer with no wallet. */
export function getWarpNoWalletReportedStorageKey(authId: string): string {
  return `republic-warp-no-wallet-reported-${authId}`;
}
